const PaymentMethodTypes = {
  CARD: 'CARD',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
} as const;

export default PaymentMethodTypes;
